import Skeleton from '@material-ui/lab/Skeleton'
import {useEvent} from 'Event/EventProvider'
import {Attendee} from 'Event/attendee'
import {useAsync} from 'lib/async'
import {PaginatedCollection} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useBroadcastForm} from 'organization/Event/Broadcasts/BroadcastForm'
import {useOrganization} from 'organization/OrganizationProvider'
import React, {useCallback} from 'react'

export default function NumAttendeesSummary() {
  const {channel} = useBroadcastForm()

  // For SMS, we'll display a checkbox the user needs to agree to instead.
  if (channel === 'sms') {
    return null
  }

  return <Content />
}

function Content() {
  const {data: numAttendees} = useNumAttendees()

  if (numAttendees === null) {
    return <Skeleton />
  }

  const isPlural = numAttendees === 0 || numAttendees > 1

  const message = isPlural
    ? `${numAttendees} Attendees match the given criteria.`
    : `${numAttendees} Attendee matches the given criteria.`

  return <div>{message}</div>
}

function useNumAttendees() {
  const {attendeeQuery, filterRules} = useBroadcastForm()
  const {event} = useEvent()
  const {client} = useOrganization()

  const request = useCallback(() => {
    if (filterRules) {
      const url = api(`/events/${event.id}/attendees/query`)
      return client
        .post<PaginatedCollection<Attendee>>(url, filterRules)
        .then((p) => p.total)
    }

    const baseUrl = api(`/events/${event.id}/attendees`)
    const url = attendeeQuery ? `${baseUrl}${attendeeQuery}` : baseUrl

    return client.get<PaginatedCollection<Attendee>>(url).then((p) => p.total)
  }, [client, event.id, attendeeQuery, filterRules])

  return useAsync(request)
}
